import { render, staticRenderFns } from "./ClubHome.vue?vue&type=template&id=60ff28c7"
import script from "./ClubHome.vue?vue&type=script&lang=js"
export * from "./ClubHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports